/* Session-only shopping context. No customer identity, analytics or external requests. */
(function () {
  'use strict';
  if (window.psNavigationLoaded) return;
  window.psNavigationLoaded = true;
  var contextKey = 'ps-shopping-context-v1';
  var homeKey = 'ps-home-context-v1';
  function read(key) {
    try {
      var value = JSON.parse(sessionStorage.getItem(key));
      return value && Date.now() - value.savedAt < 86400000 ? value : null;
    } catch (_) { return null; }
  }
  function store(key, value) {
    try { value.savedAt = Date.now(); sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function localURL(value) {
    try { var url = new URL(value, location.href); return url.origin === location.origin ? url : null; } catch (_) { return null; }
  }
  function homeURL(mode) {
    var url = new URL(document.body.dataset.psRootUrl || '/', location.origin);
    var saved = read(homeKey), original = saved && localURL(saved.url);
    ['preview_theme_id', '_ab', '_fd', '_sc'].forEach(function (key) {
      var value = new URL(location.href).searchParams.get(key) || (original && original.searchParams.get(key));
      if (typeof value === 'string' && value !== '') url.searchParams.set(key, value);
    });
    if (saved) url.searchParams.set('ps_return', mode);
    if (mode === 'shop') url.hash = 'ps-home-products';
    return url.pathname + url.search + url.hash;
  }
  function configureReturns(scope) {
    var saved = read(contextKey), prior = saved && localURL(saved.url);
    scope.querySelectorAll('[data-ps-return-home]').forEach(function (link) { link.href = homeURL('position'); });
    scope.querySelectorAll('[data-ps-continue-shopping]').forEach(function (link) { link.href = homeURL('shop'); });
    scope.querySelectorAll('[data-ps-return-context]').forEach(function (link) {
      if (!prior || prior.pathname === location.pathname || !/\/products\//.test(prior.pathname)) return;
      link.href = prior.pathname + prior.search + prior.hash;
      link.textContent = 'Back to product';
      link.title = saved.title || 'Return to the product you were viewing';
      link.hidden = false;
    });
    var stackNames = { 'essentials-stack': 'Essentials Stack', 'anabolic-stack': 'Anabolic Stack', 'vitality-stack': 'Vitality Stack', 'hydration-stack': 'Hydration Stack', 'precision-mind-stack': 'Precision Mind Stack', 'performance-stack': 'Performance Stack' };
    var stackHandle = new URLSearchParams(location.search).get('ps_return_product');
    var main = document.querySelector('#MainContent');
    if (document.body.classList.contains('product') && main && stackNames[stackHandle] && !main.querySelector('[data-ps-stack-return]')) {
      var stackURL = prior && prior.pathname.endsWith('/products/' + stackHandle) ? prior : new URL((document.body.dataset.psRootUrl || '/') + 'products/' + stackHandle, location.origin);
      var preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) stackURL.searchParams.set('preview_theme_id', preview);
      var back = document.createElement('nav');
      back.className = 'ps-product-return';
      back.setAttribute('data-ps-stack-return', '');
      back.setAttribute('aria-label', 'Return to the stack');
      var link = document.createElement('a');
      link.href = stackURL.pathname + stackURL.search + stackURL.hash;
      link.textContent = '← Back to ' + stackNames[stackHandle];
      back.appendChild(link);
      main.insertBefore(back, main.firstChild);
    }
  }
  function saveContext() {
    if (!document.body.matches('.index, .product, .collection')) return;
    var heading = document.querySelector('main h1');
    store(contextKey, { url: location.href, title: heading ? heading.textContent.trim() : document.title });
  }
  function syncMobile() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767.98px)').matches) {
      document.body.classList.remove('ps-mobile-purchase-visible');
      document.documentElement.style.setProperty('--ps-mobile-bottom', '0px');
      return;
    }
    var sticky = document.querySelector('sticky-add-cart.show-sticky-cart.sticky_mobile--show');
    var active = sticky && getComputedStyle(sticky).display !== 'none' && getComputedStyle(sticky).visibility !== 'hidden';
    document.body.classList.toggle('ps-mobile-purchase-visible', Boolean(active));
    var nav = document.querySelector('mobile-navigation-bar.show');
    var bottom = active ? sticky.getBoundingClientRect().height : nav && getComputedStyle(nav).display !== 'none' ? nav.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ps-mobile-bottom', Math.ceil(bottom) + 'px');
  }
  function init() {
    configureReturns(document);
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]'), target = link && localURL(link.href);
      if (!target || target.pathname === location.pathname || event.defaultPrevented) return;
      saveContext();
    });
    var queued = false;
    function scheduleMobile() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncMobile(); });
    }
    var observer = new MutationObserver(scheduleMobile);
    document.querySelectorAll('sticky-add-cart, mobile-navigation-bar').forEach(function (element) {
      observer.observe(element, { attributes: true, attributeFilter: ['class', 'style'] });
      if (window.ResizeObserver) new ResizeObserver(scheduleMobile).observe(element);
    });
    window.addEventListener('resize', scheduleMobile, { passive: true });
    window.addEventListener('pageshow', function () { configureReturns(document); scheduleMobile(); });
    document.addEventListener('shopify:section:load', function (event) { configureReturns(event.target); scheduleMobile(); });
    scheduleMobile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
